import { CRUDEntity } from "../../abstracts/CRUDEntity";

export class BusinessSettings extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'business-setting';
        this.urlRoot = '/settings/business';
        this.sectionRootUrl = '/settings';

    }
}
